import { OfferLinkDetail } from "components/other/OfferDetail/OfferLinkDetail.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum, RoleEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getOfferDetailHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link/"
)({
    component: OfferLinkDetailPage,
    staticData: {
        permissions: [PermissionEnum.OfferLinkView],
        showInSideMenu: false,
        label: "pages.offer.detail.link.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.detail.link.title"),
    }),
});

function OfferLinkDetailPage() {
    const { offerId } = Route.useParams();
    const userUtils = useUser();

    return (
        <TenantPage
            headerNavigationItems={getOfferDetailHeaderItems}
            editLink={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? {
                          to: "/offer/edit/$offerId/general",
                          params: { offerId: offerId },
                      }
                    : null
            }
        >
            <OfferLinkDetail key={offerId} offerId={offerId} />
        </TenantPage>
    );
}
